import { Stack, SxProps, Theme, useTheme } from "@mui/material";
import BaseTypography from "@ui/atoms/BaseTypography/BaseTypography";
import {
  CircularProgressWithContent,
  CircularProgressWithContentVariant
} from "@ui/atoms/CircularProgressWithContent/CircularProgressWithContent";

export interface LoadingStatusContentProps {
  title: string;
  message: string;
  value?: number;
  sx?: SxProps<Theme>;
}

export const LoadingStatusContent = ({
  message,
  sx,
  title,
  value
}: LoadingStatusContentProps) => {
  const theme = useTheme();

  return (
    <Stack
      spacing={2}
      sx={[
        {
          alignItems: "center",
          p: 1,
          width: "100%"
        },
        ...(Array.isArray(sx) ? sx : [sx])
      ]}
    >
      <CircularProgressWithContent
        variant={CircularProgressWithContentVariant.Branded}
        {...(value !== undefined && { value })}
      />
      <Stack
        sx={{
          alignItems: "center"
        }}
      >
        <BaseTypography
          text={title}
          variant="body2"
          weight="semiBold"
          sx={{
            color: theme.vars.palette.text.primary,
            mb: 0.5,
            textAlign: "center"
          }}
        />
        <BaseTypography
          text={message}
          variant="body2"
          weight="regular"
          sx={{ color: theme.vars.palette.text.secondary, textAlign: "center" }}
          dataTestId="loading-status-content"
        />
      </Stack>
    </Stack>
  );
};
